export default __webpack_public_path__ + "static/media/incidents.6718981a.svg";